export default __webpack_public_path__ + "static/media/fastener-placement-rectangle-rounded-bottom.4722ddb3.webp";